module.exports = __webpack_public_path__ + "img/twittericon.cf15e693.svg";